/**
 * Wrap tiny-slider within a class to improve 
 * responsive management. 
 * 
 * Tiny Slider is an "object" only. This class accept
 * and "object", or a "function" returning and object.
 * 
 * If options are a function, the slider will be destroy,
 * than rebuild on window resize. This allow to change
 * the configuration base on media-query.
 */

import { tns } from "tiny-slider/src/tiny-slider";
import { Events } from "tiny-slider/src/helpers/events";

class TinySlider {
    constructor(opts) {
        this._opts = opts
        this._isOptsFn = typeof this._opts === 'function'
        this._windowWidth = window.innerWidth
        this._timeout = null
        this._slider = null
        this._tnsProps = ['version', 'getInfo', 'goTo', 'play', 'pause', 'isOn', 'updateSliderHeight', 'refresh', 'rebuild']
        
        this._resizeHandler = this._resize.bind(this)

        if (this._isOptsFn) {
            window.addEventListener('resize', this._resizeHandler)
        }

        // Replace slider events, with own events, to preserve between destroy / build
        this.events = new Events();
        
        this.build()
    }

    build() {
        this._sliderDestroy()
        this._slider = tns(this._isOptsFn ? this._opts() : this._opts)
        this._tnsProps.forEach(prop => this[prop] = this._slider[prop])

        // Hijack to emit in both our emit, and the slider emit
        const emit = this._slider.events.emit.bind(this._slider.events)
        this._slider.events.emit = (eventName, data) => {
            emit(eventName, data)
            this.events.emit(eventName, data)
        }
    }

    destroy() {
        this._sliderDestroy()

        window.removeEventListener('resize', this._resizeHandler)

        delete this._resizeHandler

        delete this._opts
        delete this._isOptsFn
        delete this._windowWidth
        delete this._timeout
        delete this._slider
        delete this._tnsProps
    }

    _sliderDestroy() {
        if (this._slider && this._slider.destroy) {
            this._slider.destroy()
        }
        this._tnsProps.forEach(prop => delete this[prop])
        this._slider = null
    }

    _resize() {
        clearTimeout(this._timeout)
        this._timeout = setTimeout(() => {
            const windowWidth = window.innerWidth
            if (windowWidth !== this._windowWidth) {
                this.build()
                this._windowWidth = windowWidth
            }
        }, 100)
    }

}

export { TinySlider }
export default TinySlider